<template>
    <div class="pct-toolbar">
        <a-input-search
            v-model="localSearch"
            :placeholder="searchPlaceholder"
            class="pct-search"
            size="large"
        />
        <div class="pct-actions">
            <SupsisButton
                v-if="canCreateTitle"
                primary
                classNames="pct-btn"
                @click="$emit('create-title')"
            >
                <md-icon style="color: white">add</md-icon>
                {{ titleButtonText }}
            </SupsisButton>
            <SupsisButton
                primary
                classNames="pct-btn"
                @click="$emit('create-content')"
            >
                <md-icon style="color: white">add</md-icon>
                {{ contentButtonText }}
            </SupsisButton>
        </div>
    </div>
</template>

<script>
import SupsisButton from "../../../components/SupsisButton.vue";

export default {
    name: "PreparedContentsToolbar",
    components: {
        SupsisButton,
    },
    props: {
        value: {
            type: String,
            default: "",
        },
        searchPlaceholder: {
            type: String,
            default: "",
        },
        canCreateTitle: {
            type: Boolean,
            default: false,
        },
        titleButtonText: {
            type: String,
            default: "",
        },
        contentButtonText: {
            type: String,
            default: "",
        },
    },
    computed: {
        localSearch: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit("input", v);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.pct-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 20px 0;
}

.pct-search {
    flex: 1;
    max-width: 400px;
}

.pct-actions {
    display: flex;
    align-items: center;
    gap: 10px;

    ::v-deep .pct-btn {
        i,
        .material-icons,
        .md-icon {
            color: #ffffff !important;
        }
    }
    
    ::v-deep .supsis-button.primary.pct-btn {
        i,
        .material-icons,
        .md-icon {
            color: #ffffff !important;
        }
    }
}
</style>
